import React, { ChangeEvent, useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Box, InputBase, debounce, Drawer, Badge } from '@mui/material';
import { Search, FilterList } from '@mui/icons-material';
import { i18n } from '../../../../translate/i18n';
import { RootState } from '../../../../store/types';
import * as actions from '../../../../store/actions';
import UsersFiltersModal from '../Modals/UsersFiltersModal';


// Custom styles for Material-UI component
const UsersFilters = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [usersModalOpen, setUsersModalOpen] = useState<boolean>(false);

  const page = 1;
  const limit = 100;
  const orderBy = "name";
  const order = "asc";

  const selectedRoles = useSelector((state: RootState) => state.scheduledServices.filtersUsers.roles);
  const selectedCompanies = useSelector((state: RootState) => state.scheduledServices.filtersUsers.companies);
  const selectedSiteId = useSelector((state:RootState) => state.scheduledServices.selectedSiteId);
  
  const fetchUsers = useCallback((searchText: string) => dispatch(actions.fetchUsersScheduledServices(page, limit, searchText, orderBy, order, selectedSiteId, selectedRoles, selectedCompanies)),
  [page, limit, order, orderBy, selectedSiteId, selectedRoles, selectedCompanies])
  
  useEffect(() => {
    fetchUsers(searchText);
  }, [page, limit, order, orderBy, selectedSiteId, selectedRoles, selectedCompanies]);
  
  const debounceSearch = useCallback(debounce((text: string) => {
    fetchUsers(text);
  }, 300), [selectedSiteId]);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement| HTMLTextAreaElement>) => {
    setSearchText(event.target.value);
    debounceSearch(event.target.value);
  };

  return (
    <>
      <Box sx={styles.filtersContainer}>
        <Box style={styles.searchRow}>
          <Search style={styles.searchIcon} />
          <InputBase
            style={styles.search}
            value={searchText}
            onChange={handleSearchChange}
            placeholder={ i18n.t('scheduledServicesUsersFilters.searchUsers') }
          />
        </Box>
        <Badge badgeContent={selectedRoles.length + selectedCompanies.length} color='error' invisible={selectedRoles.length + selectedCompanies.length === 0}>
          <Button
            variant='contained'
            onClick={() => setUsersModalOpen(true)}
            style={styles.buttonFilter}
          >
            { i18n.t('scheduledServicesUsersFilters.usersFilters') as string }<FilterList style={styles.buttonFilterIcon} />
          </Button>
        </Badge>
      </Box>
      <Drawer
        variant="temporary"
        anchor="right"
        onClose={() => setUsersModalOpen(false)}
        open={usersModalOpen}>
          <UsersFiltersModal closeModal={() => setUsersModalOpen(false)} />
      </Drawer>
    </>
  );
}

export default UsersFilters;

const styles = {
  filtersContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '50px',
    maxWidth: '100vw',
  },
  search: {
    flex: 1,
    marginLeft: '8px',
  },
  searchRow: {
    marginTop: '10px',
    maxWidth: '50%',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #ccc',
    padding: '2px 4px',
    borderRadius: '5px',
    marginBottom: '10px',
    marginRight: '10px',
    width: '60%',
  },
  searchIcon: {
    color: '#ccc'
  },
  buttonFilterIcon: {
    marginLeft: '5px'
  },
  buttonFilter: {
    backgroundColor: 'green',
    height: '2.3rem',
    width: '13rem',
    padding: '1rem',
    color: '#fff',
  },
}
